"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/common/image/image";
import imageUrl from "@/sanity/utilities/imageUrl";
import { type AdTypeOne, type AdTypeTwo, type AdTypeThree } from "@/sanity/sanity.types";
import Link, { LinkStyle, LinkType } from "@/components/common/link/link";
import ArrowIcon, { ArrowIconStyle } from "@/components/common/arrow-icon/arrow-icon";
export enum AdStyle {
  TYPE_ONE = "adTypeOne",
  TYPE_TWO = "adTypeTwo",
  TYPE_THREE = "adTypeThree",
}
interface IAdProps {
  data: AdTypeOne | AdTypeTwo | AdTypeThree;
  adStyle: AdStyle;
}
const Ad = props => {
  const $ = _c(29);
  const {
    data,
    adStyle
  } = props;
  let t0;
  if ($[0] !== adStyle) {
    t0 = d => adStyle === AdStyle.TYPE_ONE;
    $[0] = adStyle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isTypeOne = t0;
  let t1;
  if ($[2] !== adStyle) {
    t1 = d_0 => adStyle === AdStyle.TYPE_TWO;
    $[2] = adStyle;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isTypeTwo = t1;
  const isTypeThree = d_1 => adStyle === AdStyle.TYPE_THREE;
  const cta = data?.cta;
  const showBackground = adStyle === AdStyle.TYPE_ONE;
  const t2 = `flex w-full flex-col items-center justify-start gap-8 rounded-xl px-5 py-6 md:px-8 md:py-10 ${showBackground ? "mt-5 bg-[#F7F7F7]" : ""}`;
  const t3 = isTypeOne(data) ? data.question : isTypeTwo(data) ? data.title : isTypeThree(data) ? data.title : "";
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="w-60 justify-center text-center font-['Lora'] text-2xl font-semibold leading-8 text-[#373B37] md:w-full md:text-[32px] md:leading-[44px]">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data || $[7] !== isTypeTwo) {
    t5 = isTypeTwo(data) && <div className="relative mt-3 flex items-start justify-around gap-1 md:items-center md:justify-center">{data.showAIIcon && <Image src="/ads-ai-star.gif" alt="AI Star" className="absolute left-[25px] top-[-2px] h-5 w-5 md:static md:left-0 md:top-0 md:h-6 md:w-6" width={24} height={24} />}<div className="max-w-[300px] justify-center text-center text-base font-medium leading-5 text-[#4A4A4A] md:max-w-full md:pt-[2px]">{data.subTitle}</div></div>;
    $[6] = data;
    $[7] = isTypeTwo;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex w-full flex-col items-center justify-center">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== data || $[13] !== isTypeOne) {
    t7 = isTypeOne(data) && data.options && <div className="flex w-full flex-col items-center justify-center gap-3 md:grid md:grid-cols-3 md:items-stretch md:gap-6">{data.options.map(_temp)}</div>;
    $[12] = data;
    $[13] = isTypeOne;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = cta?.href ?? "#";
  const t9 = cta?.label ?? "Get";
  const t10 = cta?.label;
  let t11;
  if ($[15] !== t10) {
    t11 = <span className="justify-start text-center text-lg font-semibold leading-6 text-white">{t10}</span>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ArrowIcon style={ArrowIconStyle.Tertiary} className="white" />;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t11 || $[19] !== t8 || $[20] !== t9) {
    t13 = <div className="flex w-full items-center justify-center"><Link href={t8} linkType={LinkType.BUTTON} linkStyle={LinkStyle.PRIMARY} data-cta-id={t9} data-cta-value="Cashout" className="!w-full !rounded-xl !pb-4 !pt-4 md:!w-fit">{t11}{t12}</Link></div>;
    $[18] = t11;
    $[19] = t8;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t6 || $[24] !== t7) {
    t14 = <div className="flex flex-col items-start justify-start gap-6 self-stretch md:gap-8">{t6}{t7}{t13}</div>;
    $[22] = t13;
    $[23] = t6;
    $[24] = t7;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14 || $[27] !== t2) {
    t15 = <div className={t2}>{t14}</div>;
    $[26] = t14;
    $[27] = t2;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  return t15;
};
export default Ad;
function _temp(item, index) {
  return <Link key={index} href={item?.href ?? "#"} className="group flex !w-full flex-row items-center justify-start gap-3 rounded-xl bg-neutral-50 p-3 shadow-[0px_10px_30px_0px_rgba(0,0,0,0.06)] outline outline-1 outline-offset-[-1px] outline-neutral-600/30 transition-all duration-200 ease-in-out hover:outline-[3px] hover:outline-[rgb(0,105,143)] md:min-h-[160px] md:max-w-56 md:flex-col md:gap-6 md:p-9"><Image src={imageUrl(item?.icon?.asset).url()} alt={item?.label} className="h-8 w-8 md:h-12 md:w-12" width={32} height={32} /><div className="flex w-full justify-start text-left text-sm font-semibold leading-5 text-[#373B37] md:max-w-full md:justify-center md:text-center md:text-base md:leading-8">{item?.label}</div></Link>;
}